/**
 * Created by shiyonggao on 2019/2/25.
 */

const handle = {};

const state = {
    userInfo: [],
    selectedUserValue: 0,
    selectedUserData: null
};

const actions = {
    /**
     * 获取用户角色信息
     * @param state
     * @param commit
     * @param rootState
     * @param server_id
     */
    GET_USER_INFO({state, commit, rootState}, server_id) {
        const versionInfo = rootState.$appConfig.getVersionInfo();
        let url = versionInfo.api.app_base_url + versionInfo.api.app_user_info;

        let params = {
            merchant_shop_code: rootState.$appConfig.PARAMS.merchant_shop_code,
            user_id: rootState.$appConfig.PARAMS.user_id,
            server_id: server_id ? server_id : rootState.$appConfig.PARAMS.server_id
        };

        if (server_id) commit('LOADING', true, {root: true});
        rootState.$common.ajax({
            url: url,
            data: params,
            success(res) {
                if (res.code === 200) {
                    console.log('AJAX_GET_USER_INFO=>', res);
                    commit('SET_USER_INFO', res)
                    commit('SET_AJAX_STATUS', ['user', true], {root: true});
                    if (server_id) commit('LOADING', false, {root: true});
                }
            },
            error(res) {
                console.log('AJAX_USER_INFO_INFO_FAIL=>', res);
            }
        });
    },

    /**
     * 改变选择角色状态值
     * @param state
     * @param commit
     * @param rootState
     * @param params
     */
    CLICK_SELECTED_USER_STATUS({state, commit, rootState}, params) {
        commit('CHANGE_SELECT_DATA', params);
    }
};

const getters = {};

const mutations = {
    /**
     * 更新用户信息
     * @param state
     * @param res
     * @constructor
     */
    SET_USER_INFO(state, res) {
        if(res.result.length > 0){
            state.userInfo = res.result;
            state.selectedUserValue = 0;
            state.selectedUserData = res.result[0];
        }else{
            state.userInfo = res.result;
            state.selectedUserValue = 0;
            state.selectedUserData = null;
        }
    },

    /**
     * 改变选择角色状态值和选择角色相关值
     * @param state
     * @param res
     * @constructor
     */
    CHANGE_SELECT_DATA(state, res) {
        state.selectedUserValue = res.selected;
        state.selectedUserData = res.data
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/get_user_info.js